import { useEffect, useState } from 'react';

interface UpdateNotificationProps {
    isVisible: boolean;
    onUpdate: () => void;
    onDismiss?: () => void;
}

export default function UpdateNotification({
    isVisible,
    onUpdate,
    onDismiss,
}: UpdateNotificationProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isVisible) {
            // Pequeño delay para la animación
            setTimeout(() => setShow(true), 100);
        } else {
            setShow(false);
        }
    }, [isVisible]);

    if (!isVisible) return null;

    const handleUpdate = () => {
        setShow(false);
        setTimeout(onUpdate, 300); // Esperar a que termine la animación
    };

    const handleDismiss = () => {
        setShow(false);
        setTimeout(() => onDismiss?.(), 300);
    };

    return (
        <div
            className={`fixed top-4 right-4 z-50 max-w-md transition-all duration-300 transform ${show ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
                }`}
        >
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-2xl p-4 border border-blue-500">
                <div className="flex items-start gap-3">
                    {/* Icono */}
                    <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                        <svg
                            className="w-6 h-6 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                        </svg>
                    </div>

                    {/* Contenido */}
                    <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold mb-1">
                            Nueva versión disponible
                        </h3>
                        <p className="text-sm text-blue-100 mb-3">
                            Hay una actualización lista. Actualiza ahora para obtener las últimas mejoras.
                        </p>

                        <div className="flex gap-2">
                            <button
                                onClick={handleUpdate}
                                className="px-4 py-2 bg-white text-blue-600 rounded-lg font-medium text-sm hover:bg-blue-50 transition-colors"
                            >
                                Actualizar ahora
                            </button>
                            {onDismiss && (
                                <button
                                    onClick={handleDismiss}
                                    className="px-4 py-2 bg-white/10 text-white rounded-lg font-medium text-sm hover:bg-white/20 transition-colors"
                                >
                                    Más tarde
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Botón cerrar */}
                    {onDismiss && (
                        <button
                            onClick={handleDismiss}
                            className="flex-shrink-0 text-white/80 hover:text-white transition-colors"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
